import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import {
    WidgetGetListRequest, WidgetUpdateRequest, CrudList,
    Widget, RestApiResponse, WidgetDeleteRequest,
    WidgetView, WidgetViewRequest,
} from '@ls-front/sharable';

import { ApiService } from './api.service';

@Injectable()
export class WidgetService {
    constructor(private api: ApiService) {
    }

    public getWidgetList(queryParams: WidgetGetListRequest = {}): Observable<CrudList<Widget>> {
        return this.api.post<CrudList<Widget>>('/rest_api_v3/widget/get-list', queryParams);
    }

    public update(data: WidgetUpdateRequest): Observable<RestApiResponse> {
        return this.api.post<RestApiResponse>('/rest_api_v3/widget/update', data);
    }

    public delete(data: WidgetDeleteRequest): Observable<RestApiResponse> {
        return this.api.post<RestApiResponse>('/rest_api_v3/widget/delete', data);
    }

    public view(data: WidgetViewRequest): Observable<WidgetView> {
        return this.api.post<WidgetView>('/rest_api_v3/widget/view', data);
    }
}
